import React from "react";
import TTLAsyncProxy from "../../common/TTLAsyncProxy";
import * as yup from "yup";
import {TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import HTML from "../../common/HtmlHelpers";
import Utils from "../../common/Utils";
import SmartDialog from "../../components/SmartDialog";
import {Form, Formik} from "formik";
import {CustomFilterFrame} from "../../components/CRUDView";
import {Async as AsyncSelect, components} from "react-select";
import ThreeLineItemRender from "../../components/Elements/ThreeLineItemRender";
import StandardValue from "../../common/StandardValue";
import {Button} from "reactstrap";

export class ChangeServiceProviderDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = ChangeServiceProviderDialog.getInitialState();
        this.proxy = TTLAsyncProxy.getInstance();
        this.validationSchema = yup.object().shape({
            owner: yup.mixed().required().label("Service Provider")
        });
    }

    static getInitialState(state = {}) {

        return {
            entity: state.entity || '',
            id: state.id || 0,
            onChange: state.onChange || null,
            owner: state.owner || null,
            isBusy: false
        };

    }


    show(params) {

        this.setState(ChangeServiceProviderDialog.getInitialState(params), () => {

            //  show dialog
            this._dlg.show();

        });

    }

    /**
     * Change Service Provider
     * @return {Promise<void>}
     */
    changeServiceProvider = async (values) => {

        try {

            const {entity, id} = this.state;

            if ((await this.proxy.processRequest(TractorOwnerEndpoints.transferOwnership(values.owner.instance.id, entity, id))).ok) {

                //   hide dialog
                this._dlg.hide();

                //   toast provider changed
                HTML.toastSuccess('Service provider changed successfully');

                //   invoke callback
                if (this.state.onChange) {
                    this.state.onChange();
                }
            }
        } catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }

    };

    render() {

        return <SmartDialog ref={r => this._dlg = r}
                            title={<span><i className="fa fa-exchange"/> Change Service Provider</span>}>

            <Formik validationSchema={this.validationSchema}
                    initialValues={{
                        owner: null
                    }}
                    onSubmit={async (values, {setSubmitting}) => {

                        if (window.confirm('Are you sure you really want to proceed?')) {
                            await this.changeServiceProvider(values);
                        }

                        setSubmitting(false);
                    }}>
                {({values, isValid, setFieldValue}) => (<Form>


                    <CustomFilterFrame>
                        <h5>Please select new service provider</h5>
                        <span><b>Hint:</b> This wizard ensures all ownership details are effectively transferred to new service provider</span>
                    </CustomFilterFrame>

                    <AsyncSelect name="owner"
                                 defaultOptions
                                 cacheOptions
                                 placeholder="Select service provider..."
                                 value={values['owner']}
                                 isOptionDisabled={option => option.instance.id === this.state.owner}
                                 onChange={async value => {
                                     setFieldValue('owner', value);
                                 }}
                                 components={{
                                     Option: ({children, ...props}) => {

                                         const owner = props.data.instance;
                                         return <components.Option {...props}>

                                             <ThreeLineItemRender media={owner.media}
                                                                  line1Value={owner.name}
                                                                  line2Prefix="Phone"
                                                                  line2Value={owner.user.phone}
                                                                  line3Prefix={"Email"}
                                                                  line3Value={<StandardValue
                                                                      value={owner.user.email}/>}/>

                                         </components.Option>

                                     }
                                 }}
                                 loadOptions={async (value) => {

                                     try {

                                         const res = await this.proxy.processRequest(TractorOwnerEndpoints.getUrl(), {
                                             search: {
                                                 keyword: value,
                                                 method: 'inside',
                                                 fields: ['name', 'user.email', 'user.phone']
                                             },
                                             pagination: {page: 1, perPage: 5},
                                             include: ['media', 'user']
                                         });

                                         return res.getPayload().map(t => ({label: t.name, value: t.id, instance: t}));
                                     } catch (e) {

                                         // failed to load query

                                     }

                                 }}/>

                    <hr/>

                    <Button color={"green"} disabled={!isValid} block>
                        <i className="fa fa-check"/> Apply Changes
                    </Button>


                </Form>)}

            </Formik>

        </SmartDialog>
    }
}



// WEBPACK FOOTER //
// ./src/views/Tractorowners/ChangeServiceProviderDialog.js